import { useMemo } from "react";
import { useAppSelector } from "../redux-store/hooks";

export const useRole = () => {
  const userRole = useAppSelector((state) => state.auth.role);

  const isAdmin = useMemo(() => {
    return userRole === "sdlp-superadmin";
  }, [userRole]);

  const isPilote = useMemo(() => {
    return userRole === "pilote" || userRole === "sdlp-superadmin";
  }, [userRole]);

  const isPerformer = useMemo(() => {
    return userRole === "performer";
  }, [userRole]);

  const isUser = useMemo(() => {
    return userRole === "sdlp-user";
  }, [userRole]);

  return {
    isAdmin,
    isPilote,
    isPerformer,
    isUser
  };
};
